export class HistoryClass {
    activeUrl : string;
    activePageName : string;
    activeUniqueId : string;

    HistoryId : number;
    PageName : string;
    UniqueId : number;
    HistoryXml : string;
    MdfdBy : number;
    MdfdOn : Date;
    UserNam : string;
    EmployeeName : string;
}
